var map = {
	"./Image5.png": 36595,
	"./Vechicle logo.png": 16907,
	"./amtron-logo.png": 46986,
	"./ashokstambh-removebg-preview.png": 76653,
	"./blue/ambulance.png": 26256,
	"./blue/bus.png": 46428,
	"./blue/dumper.png": 23555,
	"./blue/police.png": 19686,
	"./blue/school bus.png": 54278,
	"./blue/tanker.png": 88929,
	"./blue/taxi.png": 98012,
	"./blue/truck.png": 28703,
	"./default/ambulance.png": 92467,
	"./default/bus.png": 58491,
	"./default/dumper.png": 42922,
	"./default/police.png": 88983,
	"./default/school bus.png": 24059,
	"./default/tanker.png": 47824,
	"./default/taxi.png": 11005,
	"./default/truck.png": 1168,
	"./green/ambulance.png": 85401,
	"./green/bus.png": 781,
	"./green/dumper.png": 93252,
	"./green/police.png": 60997,
	"./green/school bus.png": 89137,
	"./green/tanker.png": 12754,
	"./green/taxi.png": 75667,
	"./green/truck.png": 9294,
	"./grey/ambulance.png": 76889,
	"./grey/bus.png": 87885,
	"./grey/dumper.png": 51556,
	"./grey/police.png": 85221,
	"./grey/school bus.png": 54545,
	"./grey/tanker.png": 25682,
	"./grey/taxi.png": 88595,
	"./grey/truck.png": 55278,
	"./icons/CAR.png": 12874,
	"./icons/logo_truck.png": 97935,
	"./icons/stqc_logo.png": 52153,
	"./image3.png": 43141,
	"./image6.png": 69368,
	"./image7.png": 90497,
	"./logo.png": 82806,
	"./orange/ambulance.png": 72574,
	"./orange/bus.png": 44990,
	"./orange/dumper.png": 16053,
	"./orange/police.png": 62500,
	"./orange/school bus.png": 4172,
	"./orange/tanker.png": 89475,
	"./orange/taxi.png": 65354,
	"./orange/truck.png": 28101,
	"./red/ambulance.png": 701,
	"./red/bus.png": 12705,
	"./red/dumper.png": 15544,
	"./red/police.png": 33793,
	"./red/school bus.png": 20901,
	"./red/tanker.png": 79326,
	"./red/taxi.png": 5663,
	"./red/truck.png": 69370,
	"./skytron-logo.png": 7785,
	"./skytron-logo2.png": 15039,
	"./skytron-logo21.png": 43910,
	"./skytron-logo3.png": 36950,
	"./skytron-logo4.png": 11209,
	"./skytronlogo.png": 16400,
	"./user icon.png": 15879,
	"./users/Untitled-removebg-preview.png": 62556,
	"assets/images/Image5.png": 36595,
	"assets/images/Vechicle logo.png": 16907,
	"assets/images/amtron-logo.png": 46986,
	"assets/images/ashokstambh-removebg-preview.png": 76653,
	"assets/images/blue/ambulance.png": 26256,
	"assets/images/blue/bus.png": 46428,
	"assets/images/blue/dumper.png": 23555,
	"assets/images/blue/police.png": 19686,
	"assets/images/blue/school bus.png": 54278,
	"assets/images/blue/tanker.png": 88929,
	"assets/images/blue/taxi.png": 98012,
	"assets/images/blue/truck.png": 28703,
	"assets/images/default/ambulance.png": 92467,
	"assets/images/default/bus.png": 58491,
	"assets/images/default/dumper.png": 42922,
	"assets/images/default/police.png": 88983,
	"assets/images/default/school bus.png": 24059,
	"assets/images/default/tanker.png": 47824,
	"assets/images/default/taxi.png": 11005,
	"assets/images/default/truck.png": 1168,
	"assets/images/green/ambulance.png": 85401,
	"assets/images/green/bus.png": 781,
	"assets/images/green/dumper.png": 93252,
	"assets/images/green/police.png": 60997,
	"assets/images/green/school bus.png": 89137,
	"assets/images/green/tanker.png": 12754,
	"assets/images/green/taxi.png": 75667,
	"assets/images/green/truck.png": 9294,
	"assets/images/grey/ambulance.png": 76889,
	"assets/images/grey/bus.png": 87885,
	"assets/images/grey/dumper.png": 51556,
	"assets/images/grey/police.png": 85221,
	"assets/images/grey/school bus.png": 54545,
	"assets/images/grey/tanker.png": 25682,
	"assets/images/grey/taxi.png": 88595,
	"assets/images/grey/truck.png": 55278,
	"assets/images/icons/CAR.png": 12874,
	"assets/images/icons/logo_truck.png": 97935,
	"assets/images/icons/stqc_logo.png": 52153,
	"assets/images/image3.png": 43141,
	"assets/images/image6.png": 69368,
	"assets/images/image7.png": 90497,
	"assets/images/logo.png": 82806,
	"assets/images/orange/ambulance.png": 72574,
	"assets/images/orange/bus.png": 44990,
	"assets/images/orange/dumper.png": 16053,
	"assets/images/orange/police.png": 62500,
	"assets/images/orange/school bus.png": 4172,
	"assets/images/orange/tanker.png": 89475,
	"assets/images/orange/taxi.png": 65354,
	"assets/images/orange/truck.png": 28101,
	"assets/images/red/ambulance.png": 701,
	"assets/images/red/bus.png": 12705,
	"assets/images/red/dumper.png": 15544,
	"assets/images/red/police.png": 33793,
	"assets/images/red/school bus.png": 20901,
	"assets/images/red/tanker.png": 79326,
	"assets/images/red/taxi.png": 5663,
	"assets/images/red/truck.png": 69370,
	"assets/images/skytron-logo.png": 7785,
	"assets/images/skytron-logo2.png": 15039,
	"assets/images/skytron-logo21.png": 43910,
	"assets/images/skytron-logo3.png": 36950,
	"assets/images/skytron-logo4.png": 11209,
	"assets/images/skytronlogo.png": 16400,
	"assets/images/user icon.png": 15879,
	"assets/images/users/Untitled-removebg-preview.png": 62556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35175;